import { MenuItem } from '@app/types';
import itemStyle from './itemMenu.module.css';
import { URL_DELIVERY_PHOTOS_THUMBS } from '@app/config/urls';
import { getBRCurrencyFormat } from '@app/utils/formmater';
import { useRestaurantContext } from '@app/pages/Restaurant/context';
import { Colors } from '@app/config/colors';
import Add from '@app/components/Icons/Add';
import ShimmerImage from '@app/components/ShimmerImage';
import { MenuItemFavorited, MenuItemTypeGuard } from '@app/types/menu-item';
import cls from 'classnames';
import { TagManager } from '@app/utils/tag-manager';

type Props = {
  menuItem: MenuItemFavorited | MenuItem;
  onAddClick: (menuItem: MenuItem) => void;
  isPizzaItem: boolean;
};

export default function MenuItemCard({ menuItem, onAddClick, isPizzaItem }: Props) {
  const { primaryColor, secondaryColor } = useRestaurantContext();

  function getPriceLabel() {
    if (menuItem.preco > 0) return getBRCurrencyFormat(menuItem.preco);
    if (menuItem.precoApartirDe && !isPizzaItem) return `A partir de ${getBRCurrencyFormat(menuItem.precoApartirDe)}`;
    return '';
  }

  function handleOnClick() {
    onAddClick(menuItem);
  }

  const name = MenuItemTypeGuard.isFavorited(menuItem) ? menuItem.nameWithMenuLabel : menuItem.nome;

  return (
    <div className={cls(itemStyle.container, TagManager.Classes.ViewItemMenu)} onClick={handleOnClick}>
      {menuItem.foto && (
        <div className={itemStyle.boxPictureItem}>
          <ShimmerImage
            src={URL_DELIVERY_PHOTOS_THUMBS + menuItem.foto}
            width={100}
            height={100}
            layout="intrinsic"
            className={itemStyle.pictureItem}
          />
        </div>
      )}

      <div className={cls(itemStyle.boxHeaderItem, TagManager.Classes.ViewItemMenu)}>
        <div className={cls(itemStyle.boxInfoProduct, TagManager.Classes.ViewItemMenu)}>
          <h4>{name}</h4>
          {menuItem.descricao && <p>{menuItem.descricao}</p>}
        </div>

        <div className={cls(itemStyle.boxPriceBtn, TagManager.Classes.ViewItemMenu)}>
          <p>{getPriceLabel()}</p>

          <div
            className={cls(itemStyle.btnAddItem, TagManager.Classes.ViewItemMenu)}
            style={{ backgroundColor: primaryColor || Colors.DefaultPrimaryColor }}
          >
            <span
              className={TagManager.Classes.ViewItemMenu}
              style={{ color: secondaryColor }}
              data-cy={`add-item-${menuItem.id}`}
            >
              Adicionar
            </span>
            <Add className={TagManager.Classes.ViewItemMenu} color={secondaryColor} />
          </div>
        </div>
      </div>
    </div>
  );
}
